"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findAll = findAll;
exports.findOne = findOne;
exports.getSummary = getSummary;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
function findAll(listQuery) {
  return (0, _request.default)({
    url: "/orderFood",
    method: "get",
    params: listQuery
  });
}
function getSummary(listQuery) {
  return (0, _request.default)({
    url: "/orderFood/summary",
    method: "get",
    params: listQuery
  });
}
function findOne(id) {
  return (0, _request.default)({
    url: "/orderFood/".concat(id),
    method: "get"
  });
}
function update(orderId, data) {
  return (0, _request.default)({
    url: "/orderFood/".concat(orderId, "/update"),
    method: "post",
    data: data
  });
}